import React from "react";
import styled from "@material-ui/core/styles/styled";
import MuiLink from "@material-ui/core/Link";
import { useHistory } from "react-router-dom";
import pxToRem from "libs/pxToRem";

const PrimaryLink = styled(MuiLink)(({ theme }) => ({
  "&.MuiLink-root": {
    fontSize: pxToRem(16),
    fontWeight: "bold",
    lineHeight: 1.5,
    color: theme.palette.primary.light,
    cursor: "pointer",
    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
}));

const MutedLink = styled(MuiLink)({
  "&.MuiLink-root": {
    fontSize: pxToRem(16),
    fontWeight: "bold",
    lineHeight: 1.5,
    color: "#bdbdbd",
    cursor: "pointer",
    "&:hover": {
      color: "#999999",
    },
  },
});

const PrimaryRouterLink: React.FC<{
  to: string;
  children?: React.ReactNode;
}> = ({ to, children }) => {
  const history = useHistory();
  return (
    <PrimaryLink
      href={to}
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        history.push(to);
      }}
    >
      {children}
    </PrimaryLink>
  );
};

export { PrimaryLink, MutedLink, PrimaryRouterLink };
